<!-- 任务列表 -->
<template>
  <div class="basicStyle">
    <div class="bg_fff">
      <div class="querySearch">
        <div class="searchItem">
          <span>任务名称：</span>
          <el-select
            v-model="queryInfo.name"
            filterable
            placeholder="支持关键词模糊查询"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="item in nameOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="searchItem">
          <span>创建时间：</span>
          <el-date-picker
            v-model="timeFrame"
            size="small"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            @change="selectData"
            clearable
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <!-- <el-button type="primary" size="small" @click="queryTable"
        >搜索</el-button
      >
      <el-button type="warning" size="small" @click="resetQuery"
        >重置</el-button
      > -->

        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>
      </div>

      <div v-if="is_show_task" class="addInfo">
        创建任务
        <!-- <el-button type="success" size="small" @click="openImport"
        >导入自有号码</el-button
      > -->
        <MyButton
          value="导入自有号码"
          size="medium"
          type="3"
          @click="openImport"
        ></MyButton>
        <el-popover
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
          :content="selfnumber"
        >
          <!-- <i class="el-icon-question el-icon--right" slot="reference"></i> -->

          <i class="el-icon--right questionIcon" slot="reference"></i>
        </el-popover>

        <!-- <el-button
        style="margin-left: 100px"
        type="warning"
        size="small"
        @click="openKefu()"
        >导入平台号码</el-button
      > -->
        <MyButton
          style="margin-left: 100px"
          value="导入平台号码"
          size="medium"
          type="3"
          @click="openKefu"
        ></MyButton>
        <el-popover
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
          :content="preciseimport"
        >
          <!-- <i class="el-icon-question el-icon--right" slot="reference"></i> -->

          <i class="el-icon--right questionIcon" slot="reference"></i>
        </el-popover>
      </div>
      <div class="table">
        <div v-if="tableList.length">
          <TableComponents :columns="columns" :tableData="tableList">
            <template slot="crm_type" slot-scope="{ row }">
              <!-- 类型 1平台合作2自有 -->
              <span v-if="row.crm_type == 1">平台号码</span>
              <span v-if="row.crm_type == 2">自有号码</span>
            </template>
            <template slot="import_total" slot-scope="{ row }">
              <span class="operationItem" @click="importDetail(row)">{{
                row.import_total
              }}</span>
            </template>

            <template slot="totalAll" slot-scope="{ row }">
              <span class="operationItem" @click="totalAllDetail(row)">{{
                row.totalAll
              }}</span>
            </template>
            <template slot="fenpei_list" slot-scope="{ row }">
              <span v-for="(item, index) in row.fenpei_list" :key="index"
                ><span v-if="item.num"
                  >{{ item.name }} {{ item.num }}；</span
                ></span
              >
              <span v-if="row.no_fenpei_total"
                ><span style="color: red">待分配 </span>
                <span style="color: #409eff">{{
                  row.no_fenpei_total
                }}</span></span
              >
            </template>
            <template slot="operation" slot-scope="{ row }">
              <span class="operationItem" @click="Distribution(row)">分配</span>
              <span class="operationItem" @click="Execution(row)"
                >执行进度</span
              >

              <div v-if="row.crm_type == 2" style="display: inline-block">
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  popper-class="accountManage"
                >
                  <div>
                    <div @click="viewDetail(row)" class="hoverRed">编辑</div>
                    <div @click="viewDelete(row)" class="hoverRed">删除</div>
                    <div @click="importRecord(row)" class="hoverRed">
                      查看导入记录
                    </div>
                  </div>
                  <span slot="reference" class="operationItem">更多</span>
                </el-popover>
              </div>
            </template>
          </TableComponents>
        </div>
        <div v-else class="noData">
          <div class="text">暂无客户数据，请点击创建拨号任务</div>
          <div v-if="is_show_task" class="openClick">
            <el-button type="success" size="small" @click="openImport"
              >导入自有号</el-button
            >
          </div>
        </div>
      </div>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.page"
          :page-sizes="[10, 30, 50, 80]"
          :page-size="queryInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryInfo.total"
        >
        </el-pagination>
      </div>
    </div>

    <ImportOwnNumber
      ref="ImportOwnNumberRef"
      :task_name="task_name"
      @outerRefresh="outerRefresh"
    ></ImportOwnNumber>

    <!-- 客服弹窗 -->
    <el-dialog
      title=""
      :visible.sync="kefuDialogVisible"
      class="formDialog"
      width="500px"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <span>技术对接和充值：{{ kefuData.teacher_name }}</span>
        <span style="padding-bottom: 20px; padding-top: 20px"
          >联系方式：{{ kefuData.teacher_mobile }}</span
        >
        <span style="padding-bottom: 20px">微信咨询 扫码联系</span>
        <el-image
          style="width: 100px; height: 100px"
          :src="kefuData.qrcode"
          :preview-src-list="[kefuData.qrcode]"
        />
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="deleteVisible"
      class="formDialog"
      width="400px"
    >
      <div>部分数据的跟进状态存在“已执行已接通”，无法删除整个任务数据</div>
      <div>（如需删除任务号码，请前往‘编辑“进行选择性删除）</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm" size="mini">确 定</el-button>
        <el-button @click="deleteVisible = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="allotVisible"
      class="formDialog"
      width="800px"
      :show-close="true"
      :before-close="handleClose"
    >
      <div style="margin-bottom: 20px">
        <el-radio-group
          v-model="allotData.type"
          size="mini"
          @change="allotTypechange()"
        >
          <el-radio :label="1">自定义分配</el-radio>
          <el-radio :label="2">选中的员工平均分配</el-radio>
        </el-radio-group>
        <el-popover placement="top-start" width="200" trigger="hover">
          <div v-html="reassignInstructions"></div>
          <i
            class="el-icon-question el-icon--right"
            slot="reference"
            style="margin-left: 30px"
          ></i>
        </el-popover>
      </div>

      <div
        v-if="
          allotData && allotData.fenpei_list && allotData.fenpei_list.length > 0
        "
        style="
          padding: 20px;
          border: 1px solid #ddd;
          margin-bottom: 20px;
          height: 400px;
          overflow-y: scroll;
        "
      >
        <div
          v-for="(item, index) in allotData.fenpei_list"
          :key="item.id"
          style="margin-bottom: 10px"
        >
          <el-checkbox
            v-model="item.selectedState"
            @change="stateChange(item.selectedState, index, item)"
            style="margin-right: 20px; min-width: 90px; display: inline-block"
            >{{ item.name }}</el-checkbox
          >
          <el-input-number
            v-model="item.num"
            :disabled="!item.selectedState || item.disabled"
            :min="0"
            :max="item.maxNum"
            label=""
            style="margin-right: 20px"
            @change="
              (currentValue, oldValue) =>
                fenpeiTotalChange(currentValue, oldValue, item)
            "
          ></el-input-number>
          <span v-if="item.zx_total"
            >该员工已执行<span style="color: red">{{ item.zx_total }}</span
            >个,</span
          ><span v-if="item.zx_total"
            >已接通<span style="color: red">{{ item.jt_total }}</span
            >个</span
          >
        </div>
      </div>
      <div
        style="
          text-align: center;
          padding: 100px 0;
          margin-bottom: 20px;
          border: 1px solid #ddd;
        "
        v-else
      >
        暂未添加员工，请点击
        <span @click="staffAdd" style="color: #409eff">添加员工</span>
      </div>
      <div style="margin-bottom: 20px">
        已分配<span style="color: red">{{ allotData.assigned }}</span
        >条数据，还剩<span style="color: red">{{
          allotData.no_fenpei_total
        }}</span
        >条待分配
      </div>
      <div>
        <span v-for="(tag, i) in fenpei_list" :key="tag.id">
          <el-tag
            v-if="tag.num"
            closable
            size="medium"
            style="border-radius: 20px; margin-right: 10px; margin-bottom: 5px"
            @close="closeTag(tag, i)"
          >
            {{ tag.name }}{{ tag.num }}
          </el-tag>
        </span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="allotConfirm" size="mini"
          >确 定</el-button
        >
        <el-button @click="closeClick" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="verifyVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        调整后，
        <span style="color: red">{{ verifyData.name }}</span
        >已执行的
        <span style="color: red">{{ verifyData.zx_total }}</span>
        条任务数据将转移至其它人，是否继续？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verifyVisible = false">取 消</el-button>
        <el-button type="primary" @click="closeConfirm(verifyData)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="verifyVisible2"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        调整后，
        <span style="color: red">{{ verifyData2.name }}</span
        >已执行的
        <span style="color: red">{{ verifyData2.zx_total }}</span>
        条任务数据将转移至其它人，是否继续？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verifyCancel">取 消</el-button>
        <el-button type="primary" @click="confirm2(verifyData2)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="verifyVisible3"
      width="40%"
      :before-close="handleClose"
      @close="verifyCancel3"
    >
      <div>
        调整后，
        <span style="color: red">{{ verifyData3.name }}</span
        >已执行的
        <span style="color: red">{{ verifyData3.isAllotZx }}</span>
        条任务数据将转移至其它人，是否继续？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verifyCancel3">取 消</el-button>
        <el-button type="primary" @click="confirm3(verifyData3)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="verifyVisible3Arr"
      width="40%"
      :before-close="handleClose"
      @close="verifyCancel3Arr"
    >
      <div>
        调整后，
        <span v-for="item in verifyData3Arr" :key="item.id">
          <span style="color: red">{{ item.name }}</span
          >已执行的
          <span style="color: red">{{ item.isAllotZx }}</span>
          条任务数据、
        </span>
        将转移至其它人，是否继续？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="verifyCancel3Arr">取 消</el-button>
        <el-button type="primary" @click="confirm3Arr(verifyData3)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import goodsApi from "@/api/goods.js";
import commonApi from "@/api/common";
import callPhoneApi from "@/api/callphone";
import { clearObj, deepClone } from "@/utils";
import TableComponents from "@/components/TableComponents.vue";
import ImportOwnNumber from "@/components/ImportOwnNumber.vue";
import MyButton from "@/components/MyButton.vue";
// 任务列表
export default {
  name: "taskList",
  components: {
    TableComponents,
    ImportOwnNumber,
    MyButton,
  },
  data() {
    return {
      loading: false,
      queryInfo: {
        limit: 10,
        page: 1,
        total: 0,
        start_time: "",
        end_time: "",
      },
      columns: [
        //列数据
        { label: "任务名称", prop: "name" },
        { label: "任务来源", prop: "crm_type", isMyself: true },
        { label: "创建时间", prop: "created_at" },
        { label: "数据量", prop: "import_total", isMyself: true },
        { label: "已执行/已接通", prop: "totalAll", isMyself: true },
        { label: "任务分配", prop: "fenpei_list", width: 300, isMyself: true },
        { label: "操作", prop: "operation", isMyself: true },
      ],
      tableList: [],
      timeFrame: [],
      outerVisible: false,
      selfnumber: "",
      preciseimport: "",
      task_name: "",
      // callStatusDialogVisible: false, // 呼叫状态弹窗
      callStatus: -1, // 呼叫状态 -1接口失败 0：通话中， 1：已挂断
      callUser: "",
      callErrorData: {},
      kefuDialogVisible: false,
      kefuData: {},
      deleteVisible: false,
      allotVisible: false,
      deleteData: {},
      allotData: {},
      fenpei_list: [],
      nameOptions: [],
      allTaskList: [],
      is_show_task: 0,
      verifyVisible: false,
      verifyData: {},
      verifyVisible2: false,
      verifyData2: {},
      verifyVisible3: false,
      verifyData3: {},
      reassignInstructions: "",
      verifyData3Arr: [], // 平均分配时小于已执行任务显示的数据
      verifyVisible3Arr: false,
      fenpeiList: [], // 用于计算平均分配的数组
      isConfirm: false, // 是否为确认，关闭弹窗
      verifyData3ArrIsGou: false, // 是否在平均界面勾选弹窗
      verifyData3ArrTimer: null,
      isAllotTypechange: false,
    };
  },
  computed: {},
  watch: {
    "allotData.fenpei_list": {
      deep: true,
      immediate: true,
      handler: function (newV, oldV) {
        // console.log("fenpei_list change", newV[0].num,oldV[0].num);
        if (newV) {
          this.allotData.assigned = 0;
          newV.forEach((item) => {
            this.allotData.assigned += item.num;
            // console.log("222", index, item.name, item.num);
          });
          console.log("assigned", this.allotData.assigned);
          if (this.allotData.import_total >= this.allotData.assigned) {
            this.allotData.no_fenpei_total =
              this.allotData.import_total - this.allotData.assigned;
          } else {
            this.$message.error("暂无待分配数据！");
          }

          this.$forceUpdate();
        }
      },
    },
  },
  created() {
    this.getTobHideMenu();
    // this.getTobAllAcCount();
    this.getTobAllTask();
    this.getDic();
    this.queryTable();
  },
  methods: {
    verifyCancel3() {
      // 如果是确认进入关闭弹窗函数的，直接返回
      if (this.verifyData3.isConfirm) {
        this.verifyData3.isConfirm = false;
        return;
      }
      // 如果是勾选员工进入
      if (this.verifyData3.isGou) {
        console.log("取消");
        this.verifyData3 = [];
        this.fenpei_list = [];
        this.allotData.fenpei_list.forEach((item) => {
          if (item.num > 0) {
            console.log("item", item);
            item.selectedState = true;
            this.fenpei_list.push(item);
          } else {
            item.selectedState = false;
          }
        });
        this.verifyVisible3 = false;
        return;
      }
      console.log("verifyCancel3", this.verifyData3);
      this.allotData.fenpei_list.forEach((item, index) => {
        if (item.id == this.verifyData3.id) {
          this.allotData.fenpei_list[index].num = this.verifyData3.oldValue;
        }
      });
      this.verifyVisible3 = false;
    },
    // 弹窗确认改变任务分配数量
    confirm3(e) {
      console.log("confirm3", e);
      // 添加一个是否为确认键的标识
      this.verifyData3.isConfirm = true;
      // 如果是勾选员工进入
      if (this.verifyData3.isGou) {
        this.allotData.fenpei_list[this.verifyData3.$index] = this.verifyData3;
        console.log(
          "勾选",
          this.allotData.fenpei_list[this.verifyData3.$index]
        );
      }
      // this.allotData.fenpei_list.forEach((item, index) => {
      //   if (item.id == this.verifyData3.id) {
      //     this.allotData.fenpei_list[index].num = 0;
      //   }
      // });
      // var residue = 0;
      // this.allotData.fenpei_list.forEach((item) => {
      //   residue += item.num;
      // });

      // this.allotData.fenpei_list.forEach((item, index) => {
      //   item.maxNum = item.num + this.allotData.import_total - residue;
      // });
      this.verifyVisible3 = false;
    },
    confirm2(e) {
      console.log(e);
      this.allotData.fenpei_list.forEach((item, index) => {
        if (item.id == this.verifyData2.id) {
          this.allotData.fenpei_list[index].num = 0;
        }
      });
      var residue = 0;
      this.allotData.fenpei_list.forEach((item) => {
        residue += item.num;
      });

      this.allotData.fenpei_list.forEach((item, index) => {
        item.maxNum = item.num + this.allotData.import_total - residue;
      });
      this.verifyVisible2 = false;
    },
    verifyCancel() {
      this.allotData.fenpei_list.forEach((item, index) => {
        if (item.id == this.verifyData2.id) {
          this.allotData.fenpei_list[index].selectedState = true;
        }
      });

      this.verifyVisible2 = false;
    },
    outerRefresh(e) {
      console.log("outerRefresh", e);
      if (e) {
        this.resetQuery();
      }
    },
    async getTobHideMenu() {
      await goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          console.log("getTobHideMenu", res.data.is_show_task);
          this.is_show_task = res.data.is_show_task;
        }
      });
    },
    handleClose(done) {
      this.queryTable();
      done();
    },
    closeClick() {
      this.queryTable();
      this.allotVisible = false;
    },
    async getTobAllAcCount(e) {
      await commonApi
        .getTobAllAcCount({ task_id: e.id ? e.id : "" })
        .then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.length > 0) {
              res.data.forEach((item) => {
                item.selectedState = false;
                item.num = 0;
                item.staff_id = item.id;
                item.name = item.realname;
                item.disabled = false;
              });
              // this.allTaskList = res.data;
              // console.log("getTobAllAcCount", this.allTaskList);

              // 分配
              var allTaskList = res.data;
              allTaskList.forEach((itemA) => {
                // console.log("444", itemA, e.fenpei_list);
                if (e.fenpei_list) {
                  e.fenpei_list.forEach((itemB) => {
                    if (itemA.staff_id == itemB.staff_id) {
                      itemA.num = itemB.num;
                    }
                  });
                }
              });
              // console.log("555", allTaskList);

              this.allotData = e;
              this.allotData.type = e.allot_type;
              this.allotData.assigned = 0;
              this.fenpei_list = [];
              allTaskList.forEach((item) => {
                if (item.num && item.num > 0) {
                  item.selectedState = true;
                  this.fenpei_list.push(item);
                } else {
                  item.selectedState = false;
                }
                item.maxNum = e.import_total;

                this.allotData.assigned += item.num;

                if (this.allotData.type == 2) {
                  item.disabled = true;
                }
                // 初始值保存
                item.lastNum = item.num;
              });

              this.allotData.fenpei_list = [];
              this.allotData.fenpei_list = allTaskList;
              this.$forceUpdate(); //刷新
              console.log("666", this.allotData.fenpei_list);

              this.allotVisible = true;
            }
          }
        });
    },
    getTobAllTask() {
      commonApi.getTobAllTask().then((res) => {
        if (res.code === 200) {
          this.nameOptions = res.data;
        }
      });
    },
    staffAdd() {
      this.$router.push({
        path: "/employeesManage",
      });
    },
    closeConfirm(tag) {
      this.fenpei_list = this.fenpei_list.filter((e) => {
        return e.staff_id !== tag.staff_id;
      });
      var fenpeiList = this.allotData.fenpei_list;

      fenpeiList.forEach((item) => {
        if (item.staff_id == tag.staff_id) {
          item.selectedState = false;
          item.num = 0;
        }
      });

      if (this.allotData.type == 2) {
        var allotNum = 0;
        fenpeiList.forEach((item) => {
          item.selectedState = false;
          item.disabled = true;
          if (item.num > 0) {
            item.selectedState = true;
            allotNum++;
          }
        });
        if (allotNum > 0) {
          var pingunZhi = Math.floor(this.allotData.import_total / allotNum);
          var yushu = Math.floor(this.allotData.import_total % allotNum);
          console.log("555", pingunZhi, yushu);

          fenpeiList.forEach((item, index) => {
            if (item.selectedState) {
              item.num = pingunZhi;
              item.maxNum = pingunZhi;
            } else {
              item.num = 0;
              item.maxNum = 0;
            }
            console.log("777", index, item.num);
          });
          var diyifenpeiList = fenpeiList.find((item) => item.selectedState);
          if (yushu) {
            fenpeiList.forEach((item, index) => {
              if (item.id == diyifenpeiList.id) {
                fenpeiList[index].num = pingunZhi + yushu;
                fenpeiList[index].maxNum = pingunZhi + yushu;
              }
            });
          }
          this.allotData.fenpei_list = fenpeiList;
        }
      }

      this.verifyVisible = false;
    },
    closeTag(tag, i) {
      console.log("closeTag", tag);
      if (tag.zx_total > 0) {
        this.verifyData = tag;
        this.verifyVisible = true;
      } else {
        this.closeConfirm(tag);
      }
    },
    //分配弹窗输入框
    fenpeiTotalChange(currentValue, oldValue, row) {
      console.log("row", row);
      // 记录当前的值，切换平均分配时使用
      row.lastNum = currentValue;
      // 如果当前的值小于已执行数量
      if (currentValue < row.zx_total && currentValue < oldValue) {
        this.verifyData3 = row;
        this.verifyData3.currentValue = currentValue;
        this.verifyData3.oldValue = oldValue;
        this.verifyVisible3 = true;
        if (oldValue > row.zx_total) {
          // 被分配出去的执行数量。上一次的值大于执行总数，就执行总数减当前值（主要情况为输入框输入值）
          this.verifyData3.isAllotZx = row.zx_total - currentValue;
        } else {
          // 上一次的值不大于执行总数，就上一次的值直接减去当前值
          this.verifyData3.isAllotZx = oldValue - currentValue;
        }
      }
      var residue = 0;
      this.allotData.fenpei_list.forEach((item) => {
        residue += item.num;
      });

      this.allotData.fenpei_list.forEach((item, index) => {
        item.maxNum = item.num + this.allotData.import_total - residue;
      });

      this.fenpei_list = [];
      this.allotData.fenpei_list.forEach((item) => {
        if (item.selectedState && item.num > 0) {
          this.fenpei_list.push(item);
        }
      });
      this.$forceUpdate();
    },
    //分配弹窗勾选状态
    stateChange(value, index, item) {
      // 如果是平均分配页面，改变分配状态为false（点击取消后不回第一页）
      if (this.allotData.type == 2) {
        this.isAllotTypechange = false;
      }
      // 勾选状态
      this.verifyData3ArrIsGou = true;
      // 如果将员工勾选掉
      if (!value) {
        this.verifyData3ArrIsGou = true;
        if (this.allotData.type == 1) {
          // 有已执行数
          if (
            this.allotData.fenpei_list[index].zx_total > 0 &&
            item.lastNum > 0
          ) {
            this.verifyData3 = deepClone(this.allotData.fenpei_list[index]);
            // 上一次的数 大于 已执行数
            if (this.verifyData3.lastNum > this.verifyData3.zx_total) {
              this.verifyData3.isAllotZx = this.verifyData3.zx_total;
            } else {
              this.verifyData3.isAllotZx = this.verifyData3.num;
            }
            this.verifyData3.isGou = true;
            this.verifyVisible3 = true;
            this.verifyData3.num = 0;
            this.verifyData3.lastNum = 0;
            this.verifyData3.$index = index;
          } else {
            // 没有已执行数
            this.allotData.fenpei_list[index].num = 0;
            this.allotData.fenpei_list[index].lastNum = 0;
          }
        } else {
          // 已勾选员工数量
          let allotNum = 0;
          if (this.allotData.type == 2) {
            // 深度克隆分配列表数组
            this.fenpeiList = deepClone(this.allotData.fenpei_list);
            this.fenpeiList.forEach((item) => {
              if (item.selectedState) {
                allotNum++;
              }
            });
            if (allotNum > 0) {
              let pingJunZhi = Math.floor(
                this.allotData.import_total / allotNum
              );
              let yushu = Math.floor(this.allotData.import_total % allotNum);
              this.fenpeiList.forEach((item, idx) => {
                if (item.selectedState) {
                  item.num = pingJunZhi;
                  item.maxNum = pingJunZhi;
                } else {
                  item.num = 0;
                  item.maxNum = 0;
                }
              });
              if (yushu) {
                let diyifenpeiList = this.fenpeiList.find(
                  (item) => item.selectedState
                );
                this.fenpeiList.forEach((item, index) => {
                  if (item.id == diyifenpeiList.id) {
                    this.fenpeiList[index].num = pingJunZhi + yushu;
                    this.fenpeiList[index].maxNum = pingJunZhi + yushu;
                  }
                });
              }
              this.fenpeiList.forEach((item, index) => {
                // 上一次有编辑 并且 当前的值小于上一次的值
                if (item.lastNum && item.lastNum > item.num) {
                  // 当前的值小于了已经执行的值 并且 上一次的值小于已经执行的值
                  if (
                    item.num < item.zx_total &&
                    item.lastNum <= item.zx_total
                  ) {
                    item.isAllotZx = item.lastNum - item.num;
                    // item.lastNum = item.num;
                    this.verifyData3Arr.push(item);
                  } else if (
                    item.num < item.zx_total &&
                    item.lastNum > item.zx_total
                  ) {
                    item.isAllotZx = item.zx_total - item.num;
                    // item.lastNum = item.num;
                    this.verifyData3Arr.push(item);
                  }
                }
                item.lastNum = item.num;
              });
              console.log("verifyData3Arr", this.verifyData3Arr);
              if (this.verifyData3Arr.length) {
                this.verifyVisible3Arr = true;
              } else {
                this.allotData.fenpei_list = this.fenpeiList;
                this.fenpeiList = [];
              }
              // this.allotData.fenpei_list = this.fenpeiList;
            }
          }
          this.fenpei_list = [];
          this.allotData.fenpei_list.forEach((item) => {
            if (item.selectedState && item.num > 0) {
              this.fenpei_list.push(item);
            }
          });
          console.log("显示", this.fenpei_list);
          this.$forceUpdate();
        }
        return;
      }
      // 已勾选员工数量
      let allotNum = 0;
      if (this.allotData.type == 2) {
        // 深度克隆分配列表数组
        this.fenpeiList = deepClone(this.allotData.fenpei_list);
        this.fenpeiList.forEach((item) => {
          if (item.selectedState) {
            // console.log("item.selectedState", item.selectedState);
            allotNum++;
          }
        });
        if (allotNum > 0) {
          let pingJunZhi = Math.floor(this.allotData.import_total / allotNum);
          let yushu = Math.floor(this.allotData.import_total % allotNum);
          this.fenpeiList.forEach((item, idx) => {
            if (item.selectedState) {
              item.num = pingJunZhi;
              item.maxNum = pingJunZhi;
            } else {
              item.num = 0;
              item.maxNum = 0;
            }
          });

          if (yushu) {
            let diyifenpeiList = this.fenpeiList.find(
              (item) => item.selectedState
            );

            // fenpeiList[0].num = pingunZhi + yushu;
            // fenpeiList[0].maxNum = pingunZhi + yushu;

            this.fenpeiList.forEach((item, index) => {
              if (item.id == diyifenpeiList.id) {
                this.fenpeiList[index].num = pingJunZhi + yushu;
                this.fenpeiList[index].maxNum = pingJunZhi + yushu;
              }
            });
          }
          console.log("计算后的结果", this.fenpeiList);
          this.fenpeiList.forEach((item, index) => {
            // 上一次有编辑 并且 当前的值小于上一次的值
            if (item.lastNum && item.lastNum > item.num) {
              // 当前的值小于了已经执行的值 并且 上一次的值小于已经执行的值
              if (item.num < item.zx_total && item.lastNum <= item.zx_total) {
                item.isAllotZx = item.lastNum - item.num;
                // item.lastNum = item.num;
                this.verifyData3Arr.push(item);
              } else if (
                item.num < item.zx_total &&
                item.lastNum > item.zx_total
              ) {
                item.isAllotZx = item.zx_total - item.num;
                // item.lastNum = item.num;
                this.verifyData3Arr.push(item);
              }
            }
            item.lastNum = item.num;
          });
          console.log("verifyData3Arr", this.verifyData3Arr);
          if (this.verifyData3Arr.length) {
            this.verifyVisible3Arr = true;
          } else {
            this.allotData.fenpei_list = this.fenpeiList;
            this.fenpeiList = [];
          }
          // this.allotData.fenpei_list = this.fenpeiList;
        }
      }

      this.fenpei_list = [];
      this.allotData.fenpei_list.forEach((item) => {
        if (item.selectedState && item.num > 0) {
          this.fenpei_list.push(item);
        }
      });
      console.log("显示", this.fenpei_list);
      this.$forceUpdate();
    },
    //类型切换
    allotTypechange() {
      console.log("allotTypechange", this.allotData.type);
      var allotNum = 0;
      if (this.allotData.type == 2) {
        this.isAllotTypechange = true;
        // console.log('fenpei_list', this.allotData.fenpei_list);
        this.fenpeiList = deepClone(this.allotData.fenpei_list);
        this.fenpeiList.forEach((item) => {
          item.selectedState = false;
          item.disabled = true;
          if (item.num > 0) {
            item.selectedState = true;
            allotNum++;
          }
        });
        if (allotNum > 0) {
          var pingunZhi = Math.floor(this.allotData.import_total / allotNum);
          var yushu = Math.floor(this.allotData.import_total % allotNum);

          // console.log("555", pingunZhi, yushu);
          this.fenpeiList.forEach((item, index) => {
            if (item.selectedState) {
              item.num = pingunZhi;
              item.maxNum = pingunZhi;
            } else {
              item.num = 0;
              item.maxNum = 0;
            }
          });
          var diyifenpeiList = this.fenpeiList.find(
            (item) => item.selectedState
          );

          if (yushu) {
            // fenpeiList[0].num = pingunZhi + yushu;
            // fenpeiList[0].maxNum = pingunZhi + yushu;

            this.fenpeiList.forEach((item, index) => {
              if (item.id == diyifenpeiList.id) {
                this.fenpeiList[index].num = pingunZhi + yushu;
                this.fenpeiList[index].maxNum = pingunZhi + yushu;
              }
            });
          }
          console.log("计算后的结果", this.fenpeiList);
          this.fenpeiList.forEach((item, index) => {
            // 上一次有编辑 并且 当前的值小于上一次的值
            if (item.lastNum && item.lastNum > item.num) {
              // 当前的值小于了已经执行的值 并且 上一次的值小于已经执行的值
              if (item.num < item.zx_total && item.lastNum <= item.zx_total) {
                item.isAllotZx = item.lastNum - item.num;
                // item.lastNum = item.num;
                this.verifyData3Arr.push(item);
              } else if (
                item.num < item.zx_total &&
                item.lastNum > item.zx_total
              ) {
                item.isAllotZx = item.zx_total - item.num;
                // item.lastNum = item.num;
                this.verifyData3Arr.push(item);
              }
            }
            item.lastNum = item.num;
          });
          console.log("verifyData3Arr", this.verifyData3Arr);
          if (this.verifyData3Arr.length) {
            this.verifyVisible3Arr = true;
          } else {
            this.allotData.fenpei_list = this.fenpeiList;
            this.fenpeiList = [];
          }
          // this.allotData.fenpei_list = fenpeiList;
          // console.log('最后的结果', this.allotData.fenpei_list);
        }
      } else {
        this.allotData.fenpei_list.forEach((item) => {
          item.disabled = false;
        });
      }
      this.$forceUpdate(); //刷新
    },
    // 取消显示平均分配小于已执行弹窗
    verifyCancel3Arr() {
      if (this.verifyData3ArrTimer) {
        return;
      }
      if (this.isConfirm) {
        this.isConfirm = false;
        return;
      }
      if (this.verifyData3ArrIsGou) {
        console.log("取消1");
        this.verifyData3Arr = [];
        // 清空计算用的分配列表
        this.fenpeiList = [];
        this.fenpei_list = [];
        this.allotData.fenpei_list.forEach((item) => {
          if (item.num > 0) {
            item.selectedState = true;
            this.fenpei_list.push(item);
          } else {
            item.selectedState = false;
          }
        });
        this.allotData.type = 2;
        this.verifyData3ArrIsGou = false;
        this.verifyVisible3Arr = false;
        return;
      } else {
        if (this.isAllotTypechange) {
          this.verifyData3Arr = [];
          // 清空计算用的分配列表
          this.fenpeiList = [];
          this.allotData.type = 1;
          this.isAllotTypechange = false;
          this.verifyVisible3Arr = false;
        } else {
          console.log("返回1");
          this.verifyData3Arr = [];
          // 清空计算用的分配列表
          this.fenpeiList = [];
          this.isAllotTypechange = false;
          this.verifyVisible3Arr = false;
        }
      }
      this.verifyData3ArrTimer = setTimeout(() => {
        clearTimeout(this.verifyData3ArrTimer);
        this.verifyData3ArrTimer = null;
      }, 400);
    },
    // 确认显示平均分配小于已执行弹窗
    confirm3Arr() {
      console.log("弹窗");
      this.allotData.fenpei_list = this.fenpeiList;
      this.fenpeiList = [];
      this.verifyData3Arr = [];
      this.isConfirm = true;
      this.allotData.type = 2;
      this.verifyData3ArrIsGou = false;
      this.isAllotTypechange = false;
      this.verifyVisible3Arr = false;
      console.log("确认");
    },
    allotConfirm() {
      const dataAll = [];
      this.allotData.fenpei_list.forEach((item) => {
        if (item.num && item.num > 0) {
          dataAll.push({
            staff_id: item.staff_id,
            name: item.name,
            num: item.num,
          });
        }
      });
      if (dataAll.length <= 0) {
        this.allotVisible = false;
        return;
      }
      commonApi
        .tobAllot({
          task_id: this.allotData.id,
          type: this.allotData.type,
          task_name: this.allotData.name,
          data: JSON.stringify(dataAll),
        })
        .then((res) => {
          if (res.code === 200) {
            this.queryTable();
            this.$message({
              message: "提交分配成功！",
              type: "success",
            });
            this.allotVisible = false;
          }
        });
    },
    confirm() {
      this.viewDetail(this.deleteData);
      this.deleteVisible = false;
    },
    Execution(row) {
      // 执行进度
      // console.log("Execution", row);
      this.$router.push({
        path: "/taskExecuteProfile",
        query: { id: row.id },
      });
    },
    Distribution(row) {
      this.getTobAllAcCount(row);
    },
    viewDelete(row) {
      // 删除
      console.log("viewDelete", row);
      if (row.jt_total == 0) {
        this.$confirm("是否需要删除整个任务数据", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const res = await commonApi.tobDelTask({ id: row.id });
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.queryTable();
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.deleteVisible = true;
        this.deleteData = row;
      }
    },
    importRecord(row) {
      // 查看导入记录
      console.log("importRecord", row);
      this.$router.push({
        path: "/importDetalRecord",
        query: { id: row.id },
      });
    },
    viewDetail(row) {
      console.log("viewDetail", row);
      this.$router.push({
        path: "/editTask",
        query: { id: row.id },
      });
    },
    totalAllDetail(row) {
      this.$router.push({
        path: "/taskExecuteProfile",
        query: { id: row.id },
      });
    },
    importDetail(row) {
      this.$router.push({
        path: "/callPhone",
        query: { id: row.id },
      });
    },
    // 外呼
    // async callPhoneOpen(row = "") {
    //   await this.getMe();
    //   if (row) {
    //     this.callUser = row;
    //   }
    //   if (this.myUser.is_called == 1 || !row) {
    //     const res = await callPhoneApi.callPhone({ id: this.callUser.id });
    //     if (res.code === 200) {
    //       this.callSuccessData.bindId = res.data.bindId;
    //       this.callSuccessData.crm_id = res.data.crm_id;
    //       this.callStatusDialogVisible = true;
    //       this.callStatus = 0;
    //       this.startCallStatusQuery();
    //     } else if (res.code === 402) {
    //       this.callErrorData = res.data;
    //       this.callStatusDialogVisible = true;
    //       this.callStatus = -1;
    //     } else {
    //       this.$message.error(res.message);
    //     }
    //   } else {
    //     this.callDialogVisible = true;
    //   }
    // },
    // 打开客服弹窗
    openKefu() {
      // this.callStatusDialogVisible = false;
      this.kefuDialogVisible = true;
    },
    getDic() {
      commonApi.getInfoToName({ name: "outwardcal" }).then((res) => {
        console.log("1----", res.data);
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key === "selfnumber") {
              this.selfnumber = item.value;
            } else if (item.key === "preciseimport") {
              this.preciseimport = item.value;
            } else if (item.key == "teacher") {
              this.kefuData.qrcode = item.flag;
              let t = item.value.split("_");
              this.kefuData.teacher_name = t[0];
              this.kefuData.teacher_mobile = t[1];
              console.log(this.kefuData);
            }
          });
        }
      });

      commonApi.getInfoToName({ name: "outwardcalsm" }).then((res) => {
        console.log("2----", res.data);

        res.data.forEach((item) => {
          if (item.key == "reassignInstructions") {
            console.log("reassignInstructions----", item.value);
            this.reassignInstructions = item.value;
          }
        });
      });
    },
    openImport() {
      // this.outerVisible = true;
      this.task_name = this.getYesterDate() + this.formatDateTime();
      this.$refs.ImportOwnNumberRef.show();
      this.$refs.ImportOwnNumberRef.getTobAllAcCount();
    },
    getYesterDate() {
      var currentDate = new Date();
      var yesterDate = currentDate.getTime() - 24 * 60 * 60 * 1000;
      var oDate = new Date(yesterDate);
      var oYear = oDate.getFullYear();
      var oMonth = oDate.getMonth() + 1;
      var oDay = oDate.getDate();
      var oTime = oYear + this.prefixZero(oMonth) + this.prefixZero(oDay);
      return oTime;
    },
    prefixZero(num) {
      if (parseInt(num) < 10) {
        num = "0" + num;
      }
      return num + "";
    },
    formatDateTime() {
      var result = new Date().getTime();
      return result;
    },
    randomRange(min, max) {
      // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min;
    },
    // 列表数据
    async queryTable(_type) {
      let params = deepClone(this.queryInfo);
      const res = await commonApi.getTobTask(params);
      if (res.code == 200) {
        res.data.data.forEach((item) => {
          item.totalAll = item.zx_total + "/" + item.jt_total;
        });

        this.queryInfo.total = res.data.total;
        this.tableList = res.data.data;
      } else {
        this.$message.error(res.message);
      }
    },
    // 分页
    handleSizeChange(e) {
      //  e);
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    },

    resetQuery() {
      this.timeFrame = [];
      this.costTimeArr = [];
      this.selectTags = [];
      this.queryInfo = {
        limit: 10,
        page: 1,
        total: 0,
        start_time: "",
        end_time: "",
      };
      this.queryTable();
    },
    // 选择日期
    selectData(e) {
      //  e);
      if (e) {
        this.queryInfo.start_time = e[0];
        this.queryInfo.end_time = e[1];
      } else {
        this.queryInfo.start_time = "";
        this.queryInfo.end_time = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 10px 0;
    .el-button {
      margin: 0 5px 10px 0;
    }
  }

  // 表格数据
  .table {
    // min-height: calc(100vh - 330px);
    border: 1px solid #ddd;
    border-radius: 10px;
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem {
    display: inline-block;
    margin: 0 5px;
    cursor: pointer;
    color: rgb(87, 87, 239);
  }
  .operationItem:hover {
    color: red;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
/deep/.el-input-number {
  width: 250px;
}

/deep/.noData {
  padding-top: 200px;
  padding-bottom: 200px;
  .text {
    text-align: center;
    font-size: 16px;
    margin-bottom: 20px;
  }
  .openClick {
    text-align: center;
  }
}
/deep/.el-dialog__footer {
  text-align: center;
}
/deep/.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
/deep/.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
</style>
